<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <span class="pageTitle">
        {{ this.currentCategoryName }}
      </span>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper categoryOverviewContent" ref="contentWrapper">
      <v-row v-if="!isLoading" :key="this.currentCategory">
        <v-col
            cols="12"
            md="4"
            v-for="category in getCategories2(currentCategory)"
            :key="category.id"
            class="categoryNavigationCol"
            @click="goToCategory(category)"
        >
          <v-btn class="categoryNavigationBtn"
                 elevation="0"
          >

            <span v-text="category.category">Food</span>
            <chevron-right class="chevron_right"/>
          </v-btn>
        </v-col>
      </v-row>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import {mapActions, mapMutations, mapGetters, mapState} from 'vuex'
import axios from "axios"
import chevronRight from '@/assets/chevron/chevron_right'

export default {
name: "categoryOverview",
  components: {chevronRight},

  data:() => {
    return {
      isLoading: true,
      currentCategoryName: null,
    }
  },

  methods: {
    ...mapActions({
      setCategoryBreadcrumbs: 'setCategoryBreadcrumbs',
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    ...mapMutations({
      setCategories: 'setCategories',
      setCurrentCategory: 'setCurrentCategory',
      setStoredCategoryProducts: 'setStoredCategoryProducts',
      resetStoredCategoryProducts: 'resetStoredCategoryProducts',
      resetCurrentPosition: 'resetCurrentPosition',
      setCurrentPage: 'setCurrentPage',
      setCurrentCategoryPosition: 'setCurrentCategoryPosition'
    }),

    ...mapGetters({
      getCategoryBreadcrumbs: 'getCategoryBreadcrumbs',
      getCurrentCategory: 'getCurrentCategory'
    }),

    goBack() {
      let filter = this.getCategories.filter(val =>
          val.parent === this.getCurrentCategory()
      )

      if(filter[0] && filter[0]['parent'] !== null) {
        let parent = filter[0]['parent'];

        let subFilter = this.getCategories.filter(val =>
            val.id === parent
        )

        this.setCurrentCategory(subFilter[0]['parent'])

        this.$nextTick(function () {
          let currentCategoryPosition = this.currentCategoryPosition.length
          if (currentCategoryPosition > 0) {
            this.$refs["contentWrapper"].scrollTo(0, this.currentCategoryPosition[currentCategoryPosition -1])
            this.setCurrentCategoryPosition(false)
          }
        })
      }

      else {
        router.push({name: 'LastArticle'})
      }
    },

    goToCategory(data) {
      this.setCurrentCategoryPosition(this.$refs["contentWrapper"].scrollTop)
      let filter = this.getCategories.filter(val =>
          val.parent === data.id
      )

      if(filter.length === 1) {
        router.push({name: `Kategorieprodukte`, params: {id: filter[0]['id']}})
      }
      else if (filter.length === 0) {
        router.push({name: `Kategorieprodukte`, params: {id: data.id}})
      }
      else {
        this.setCurrentCategory(data.id)
      }
    },

    getCategories2(parent) {
      if(parent !== null) {
        let parentCategory = this.getCategories.filter(val =>
            val.id === parent
        )

        this.currentCategoryName = parentCategory[0].category
      }
      else if(parent === null) {
        this.currentCategoryName = 'Artikelkategorien'
      }

      return this.getCategories.filter(val =>
          val.parent === parent
      )
    }
  },

  computed: {
    ...mapGetters({
      getCategories: 'getCategories',
    }),

    ...mapState({
      currentCategory: 'currentCategory',
      currentCategoryPosition: 'currentCategoryPosition'
    })
  },

  mounted() {

    axios.get('/api/getCats')
        .then((result) => {
          this.setCategories(result.data)
        })
        .finally(() => this.isLoading = false)


    this.setHeaderVisibility(false)
    this.resetStoredCategoryProducts()
    this.resetCurrentPosition()
    this.setCurrentPage(1)
    if(router.currentRoute.path === '/shop/categories') {
      this.setCategoryBreadcrumbs(null)
    }
  },

  watch: {
    isLoading: {
      handler(loadingState) {
        if(!loadingState) {
          this.$nextTick(function () {
            let currentCategoryPosition = this.currentCategoryPosition.length
            if (currentCategoryPosition > 0) {
              this.$refs["contentWrapper"].scrollTo(0, this.currentCategoryPosition[currentCategoryPosition -1])
              this.setCurrentCategoryPosition(false)
            }
          })
        }
      }
    }
  }

}
</script>

<style>
  .categoryOverviewContent {
    padding-top: 15px;
  }
</style>
